<template>
  <div style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div>
    
     
      <div>
        <div>
          <div :class="header == true ? 'block' : 'block1'"  style="display: flex;justify-content: space-between;width: 100%;height:60px">
            <div id="form"  style="margin-top: 16px; margin-left: 11px;    display: flex; height: 30px;" class="form_e">
              <span @click="cleanUpEvt" class="all_text">All</span>
              <span @click="dialogVisible_one = true"  style="    line-height: 26px; width: 80px;  height: 26px;  cursor: pointer;display: flex;  border: 1px solid rgb(179, 183, 188);
                    margin-left: 10px; justify-content: center;border-radius: 5px;margin-right: 10px;    font-size: 13px;
                    color: #787373; ">Filter</span>
              <el-date-picker v-if="value1 && value1.length" v-model="value1" type="daterange" start-placeholder="收入时间" value-format="timestamp"
                end-placeholder="" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                range-separator="-" style="width: 240px;margin-left: 5px;" @change="getList"
                :class="{ 'your-css-class_box': !isValue1Empty_box }" class="border_box">
              </el-date-picker>


              <el-date-picker v-if="value3 && value3.length" v-model="value3" type="daterange" start-placeholder="有效期" value-format="timestamp"
                end-placeholder="" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                range-separator="-" style="width: 240px;margin-left: 5px;" @change="getList"
                :class="{ 'your-css-class_box': !isValue3Empty_box }" class="border_box">
              </el-date-picker>
              <el-input v-if="user" style="width: 120px;margin-left: 5px;" size="mini" placeholder="用户" v-model="user" clearable
                @change="getList" :class="{ 'vip': user && user.length != '0' }"></el-input>

              <!-- <el-input style="width: 120px;margin-top: 5px;" size="mini" placeholder="参考会员" v-model="Members" clearable
                @change="getList" :class="{ 'vip': Members && Members.length != '0' }"></el-input> -->
                <el-dropdown  @command="Members_Evt" v-show="Members_e !== '参考会员'">
                <el-button style="width:137px; height:28px;border:none;margin-left:3px" type="primary" size="mini" clearable :class="{ 'vip_e': Members_e && Members_e !== '参考会员' }">
                  {{ Members_e }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">是</el-dropdown-item>
                  <el-dropdown-item command="2">否</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>




              <el-input v-if="remark" style="width: 120px;margin-left: 5px;" size="mini" placeholder="备注" v-model="remark" clearable
                @change="getList" :class="{ 'vip': remark && remark.length != '0' }"></el-input>

              <el-dropdown   @command="vipEvt" v-show="vipName !== '新老会员' ">
                <el-button style="width:137px; height:28px;border:none;margin-left:3px" type="primary" size="mini" clearable :class="{ 'vip_e': vipName && vipName !== '新老会员' }">
                  {{ vipName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">新会员</el-dropdown-item>
                  <el-dropdown-item command="2">老会员</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-date-picker v-if="value4 && value4.length" v-model="value4" type="daterange" start-placeholder="AI初次使用" value-format="timestamp"
                end-placeholder="" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                range-separator="-" style="width: 240px;margin-left: 5px;" @change="getList"
                :class="{ 'your-css-class_box': !isValue4Empty_box }" class="border_box">
              </el-date-picker>
              <el-date-picker v-if="value5 && value5.length" v-model="value5" type="daterange" start-placeholder="AI最后使用" value-format="timestamp"
                end-placeholder="" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                range-separator="-" style="width: 240px;margin-left: 5px;" @change="getList"
                :class="{ 'your-css-class_box': !isValue5Empty_box }" class="border_box">
              </el-date-picker>
            </div>
            <div class="pagination_box">
              <el-input v-model="paginationInput" style="width: 50px" size="mini" @change="limitEvt"
                placeholder="to"></el-input>

              <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
                :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="zonghe" :pager-count="5"
                :show-total="showTotal"></el-pagination>
            </div>
          </div>
        </div>

        <div style="margin-top: 60px;overflow: unset;border-bottom: 1px solid #e1e1e1; margin-top: 1px solid #e1e1e1;">
          <el-table ref="sortTable" :data="tableData" :cell-style="rowStyle" :summary-method="getSummaries" height="55%"
            :empty-text="dataLoaded ? '暂无数据' : '正在加载数据中...'" @sort-change="sortChangeEvt" show-summary
            style="width: 100%; margin-top: 43px; overflow: none;font-size:12px">
            <el-table-column sortable="custom" prop="order_time" label="收入时间" width="100" align="left"  label-class-name="source_ID">
              <template slot-scope="props">
                    <span style="width:70px;display:flex;text-align: left;margin-left:15px;" >{{ props.row.order_time }}</span>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="amount_total" width="100" label="收入金额" align="center">
            </el-table-column>
            <el-table-column sortable="custom" prop="expire_time" label="有效期" width="150" align="left" label-class-name="source_ID">
              <template slot-scope="props">
                    <span style="width:70px;display:flex;text-align: left;margin-left:15px;" >{{ props.row.expire_time }}</span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="" width="120" label="头像" align="center">
              <template slot-scope="props">
                    <div style="display: flex;flex-direction: column; text-align: left;align-items: center;">
                        <el-avatar :src="props.row.header_img"></el-avatar>
                        <span>{{ props.row. username }}</span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column sortable="custom" prop="remark" label="备注" width="180" align="left" >
              <template slot-scope="props">
                <div class="notes_box">
                  <el-input ref="editInput" v-if="props.row.id === editShowInp" v-model="props.row.remark"
                  @keyup.enter.native="saveRemark(props.row.id)"
                  @blur.stop="saveRemark(props.row.id)" placeholder="请输入内容"></el-input>
                  <div class="name_box" @click="editShowEvt(props.row, 'remark')" v-else>
                    <span style="height: 72px; line-height: 72px">{{
                      props.row.remark
                      }}</span>
                    <i class="el-icon-edit"></i>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="recharge_count" width="220" label="该板块充值次数 " align="center">
              <template slot-scope="props">
                <span :style="{ color: props.row.recharge_count == 0 ? '#d1d1d1' : '#333' }">{{ props.row.recharge_count }}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column sortable="custom" prop="recharge_count" width="140" label="该板块充值金额" align="center">
              <template slot-scope="props">
                <span :style="{ color: props.row.recharge_count == 0 ? '#d1d1d1' : '#333' }">{{ props.row.recharge_count }}</span>
              </template>
            </el-table-column> -->

            <el-table-column sortable="custom" prop="coin" width="100" label="充值点数" align="center">
              <template slot-scope="props">
                <span :style="{ color: props.row.coin == 0 ? '#d1d1d1' : '#333' }">{{ props.row.coin }}</span>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="used_ai_coin" width="100" label="消耗点数" align="center">
              <template slot-scope="props">
                <span :style="{ color: props.row.used_ai_coin == 0 ? '#d1d1d1' : '#333' }">{{ props.row.used_ai_coin }}</span>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="ai_coin" width="220" label="剩余点数" align="left">
              <template slot-scope="props">
                <span :style="{ color: props.row.ai_coin == 0 ? '#d1d1d1' : '#333' }">{{ props.row.ai_coin }}</span>
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="vip_level" width="160" label="参考图身份" align="center">
                <template slot-scope="scope">
                    <!-- 定义映射对象，key是身份值，value包含文字和颜色 -->
                    <span :style="{ color: {1:'#1989fa',2:'#f56c6c',3:'#c0c4cc'}[scope.row.vip_level] || '#c0c4cc' }">
                    {{ {1:'会员中',2:'已过期',3:'非会员'}[scope.row.vip_level] || '非会员' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="ai_level" width="160" label="AI身份" align="center">
                <template slot-scope="scope">
                    <!-- 定义映射对象，key是身份值，value包含文字和颜色 -->
                    <span :style="{ color: {1:'#1989fa',2:'#f56c6c',3:'#c0c4cc'}[scope.row.ai_level] || '#c0c4cc' }">
                    {{ {1:'会员中',2:'已过期',3:'非会员'}[scope.row.ai_level] || '非会员' }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="model_level"  label="模型身份" align="left">
                <template slot-scope="scope">
                    <!-- 定义映射对象，key是身份值，value包含文字和颜色 -->
                    <span :style="{ color: {1:'#1989fa',2:'#f56c6c',3:'#c0c4cc'}[scope.row.model_level] || '#c0c4cc' }">
                    {{ {1:'会员中',2:'已过期',3:'非会员'}[scope.row.model_level] || '非会员' }}
                    </span>
                </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>


 
    <el-dialog :visible.sync="dialogVisible_one" width="1400" custom-class="sousuo" :show-close="false">
        <div style="height:280px;">
          <div>
            <span
              style="width: 69px;border: 1px solid #589ff9;height: 26px;font-size: 12px;line-height: 26px;color: #589ff9;border-radius: 3px;cursor: pointer;display: flex;justify-content: center;margin: 0 40px 30px 90px;"
              @click="cleanUpEvt">ALL</span>
          </div>
          <div style="height:300px;display:flex">
            <div>
              <div class="all_input">
                <span>备注</span>
                <el-input style="width: 137px;margin-top: 5px;" size="mini" placeholder="备注" v-model="remark" clearable
                  @change="getList" :class="{ 'vip': remark && remark.length != '0' }"></el-input>
              </div>
                <div class="all_input">
                  <span>用户</span>
                  <el-input style="width: 137px;margin-top: 5px;" size="mini" placeholder="用户" v-model="user" clearable
                  @change="getList" :class="{ 'vip': user && user.length != '0' }"></el-input>
                </div>
            </div>
            <div>
              <div class="all_input">
                <span>收入时间</span>
                  <el-date-picker v-model="value1" type="daterange" start-placeholder="收入时间" value-format="timestamp"
                    end-placeholder="" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                    range-separator="-" style="width: 137px;margin-top: 5px;" @change="getList"
                    :class="{ 'your-css-class_box': !isValue1Empty_box }" class="border_box">
                  </el-date-picker>
              </div>
              <div class="all_input">
                <span>有效期</span>
                <el-date-picker v-model="value3" type="daterange" start-placeholder="有效期" value-format="timestamp"
                  end-placeholder="" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                  range-separator="-" style="width: 137px;margin-top: 5px;" @change="getList"
                  :class="{ 'your-css-class_box': !isValue3Empty_box }" class="border_box">
                </el-date-picker>
              </div>
                <div class="all_input">
                  <span>AI初次使用</span>
                  <el-date-picker v-model="value4" type="daterange" start-placeholder="AI初次使用" value-format="timestamp"
                    end-placeholder="" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                    range-separator="-" style="width: 137px;margin-top: 5px;" @change="getList"
                    :class="{ 'your-css-class_box': !isValue4Empty_box }" class="border_box">
                  </el-date-picker>
                </div>
                <div class="all_input">
                  <span>AI最后使用</span>
                  <el-date-picker v-model="value5" type="daterange" start-placeholder="AI最后使用" value-format="timestamp"
                    end-placeholder="" align="right" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                    range-separator="-" style="width: 137px;margin-top: 5px;" @change="getList"
                    :class="{ 'your-css-class_box': !isValue5Empty_box }" class="border_box">
                  </el-date-picker>
                </div>
              </div>

            <div>
              <div class="all_input">
                  <span>新老会员</span>
                  <el-dropdown class="num_box" @command="vipEvt">
                  <el-button type="primary" size="mini" clearable :class="{ 'vip_e': vipName && vipName !== '新老会员' }">
                    {{ vipName }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">新会员</el-dropdown-item>
                    <el-dropdown-item command="2">老会员</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="all_input">
                <span>参考会员</span>
                <el-dropdown class="num_box" @command="Members_Evt">
                  <el-button type="primary" size="mini" clearable :class="{ 'vip_e': Members_e && Members_e !== '参考会员' }">
                    {{ Members_e }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">是</el-dropdown-item>
                    <el-dropdown-item command="2">否</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
  </div>
</template>
<script>

import { AdminIcoMeLabelApi ,editListApi } from "../../../apis/income";
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  data() {
    return {
      header: true,
      src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      //备注
      remtInput: "",
      authorIdInput: "",
      localInput: "",
      last_login: "",
      //分页输入框数据
      paginationInput: 96,
      currentPage1: 1,
      type: 4,
      //分页总数据
      total: null,


      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [
                new Date(start.setHours(0, 0, 0, 0)),
                new Date(end.setHours(23, 59, 59, 0))
              ]);
            }
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(
                current.valueOf() - (nowDayOfWeek - 1) * dayNum
              );
              const lastDate = new Date(
                new Date(firstDate).valueOf() + 6 * dayNum
              );
              // picker.$emit("pick", [firstDate, lastDate]);
              picker.$emit("pick", [
                new Date(firstDate.setHours(0, 0, 0, 0)),
                new Date(lastDate.setHours(23, 59, 59, 0))
              ]);
            }
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              // picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
              picker.$emit("pick", [
                new Date(thisMonthStartDate.setHours(0, 0, 0, 0)),
                new Date(thisMonthEndDate.setHours(23, 59, 59, 0))
              ]);
            }
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              // picker.$emit("pick", [startTime, endTime]);
              picker.$emit("pick", [
                new Date(startTime.setHours(0, 0, 0, 0)),
                new Date(endTime.setHours(23, 59, 59, 0))
              ]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const temp = new Date();
              temp.setTime(temp.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [
                new Date(temp.setHours(0, 0, 0, 0)),
                new Date(temp.setHours(23, 59, 59, 0))
              ]);
            }
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(
                new Date().getTime() - 60 * 60 * 24 * 7 * 1000
              );
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() -
                nowDayOfWeek +
                (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [
                new Date(firstDate.setHours(0, 0, 0, 0)),
                new Date(lastDate.setHours(23, 59, 59, 0))
              ]);

              // picker.$emit("pick", [firstDate, lastDate]);
            }
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            }
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            }
          }
        ]
      },
      laiyuan: null,
      input: "",
      editShowInp: null,
      editName: null,
      tableData: [],
      totalRow: null,
      //排序
      order: null,
      orField: null,
      activeId: null,
      deleteVisible: false,
      data: {},
      num: null,
      count: 0,
      pagefenye: false, //点击分页 滚动条为0
      loading: false,
      value1: "",
      value3: "",
      value4: "",
      value5: "",
      isValue1Empty_box: true,
      isValue3Empty_box: true,
      isValue4Empty_box: true,
      isValue5Empty_box: true,
      dataLoaded: false, // 表格数据是否加载完成的状态
      c: 1,
      username: null,
      user: null,
      name: null,
      Members: null,
      Members_e:'参考会员',
      NewAi: null,
      dialogVisible_one: false,
      back_status: null,
      vipName: '新老会员',
      remark: null,
      used_ai_coin: null,
      isSaving: false, // 标记是否正在保存，防止重复提交
      zonghe: null
    };
  },
  created() {
    this.loading = true;
    if (this.$store.getters.location == '') {
      this.c = 1
    }
    this.c = this.$store.getters.location;

    AdminIcoMeLabelApi({ c: this.c, kind:2, }).then(res => {
      this.tableData = res.data.order;
      this.total = res.data.count;
      this.zonghe = res.data.total
      this.amount_total = res.data.amount_total;
      this.user_total = res.data.user_total;
      this.used_ai_coin = res.data.used_ai_coin;
      
      // this.paginationInput = res.data.limit
      this.loading = false;
    });
    //监听鼠标按下抬起事件
    window.addEventListener("keydown", this.handKeyCode, true);
    window.addEventListener("keyup", this.handKeyEvt);
    const storedDateRange = sessionStorage.getItem('dateRange');
      if (storedDateRange) {
          const dateRange = JSON.parse(storedDateRange);
          // 将秒转换回毫秒
          this.value1 = [dateRange.start * 1000, dateRange.end * 1000];
          // 可以在这里调用 getList() 方法，使用存储的日期信息进行数据加载
          this.getList();
      }


  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);
  },
  mounted() {
    //监听页面滚动条事件
    window.addEventListener("scroll", e => this.imgScrollEvt(e), true);
    this.c = this.$store.getters.location;

  },
  methods: {
    saveRemark(id) {
            // 如果正在保存，直接返回，避免重复调用
            if (this.isSaving) return;

            this.isSaving = true;
            editListApi({
                id: id,
                field: this.editName,
                val: this.$refs.editInput.nativeInputValue ,
            }).then((res) => {
                this.editShowInp = null;
            }).finally(() => {
                // 无论成功失败，都重置保存标记
                this.isSaving = false;
            });
        },
    Members_Evt(res) {
      switch (res) {
        case "1":
          this.Members_e = "是";
          break;
        case "2":
          this.Members_e = "否";
          break;
      }
      this.Members = res;

      this.getList();
    },

    vipEvt(res) {
      switch (res) {
        case "1":
          this.vipName = "新会员";
          break;
        case "2":
          this.vipName = "老会员";
          break;
      }
      this.back_status = res;

      this.getList();
    },
    //新  增
    tnachuang() {
      this.dialogVisible_one = true
    },
    //分页只显示前三页加总数
    showTotal(total) {
      return `共 ${total} 页`;
    },
    //按下键盘事件
    handKeyCode(e) {
      e = e || window.event;
    },

    limitEvt() {
      this.getList();
    },
    //滑动事件
    imgScrollEvt(e) {
      var e =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        e ||
        document.body.scrollTop;
      //点击分页 滚动条为0
      if (this.pagefenye == true) {
        e.scrollTop = 0;
        this.pagefenye = false;
        return;
      }
    },
    //分页
    handleCurrentChange(res) {
      this.loading = true;
      setTimeout(() => {
        this.getList();
        this.loading = false;
      }, 500);
    },
    //
    rowStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label == "等级") {
        return {};
      } else if (column.label == "昵称") {
        return {};
      }
    },
    //列表排序
    sortChangeEvt(row) {
      if (row.order == "ascending") {
        this.order = "asc";
      } else if (row.order == "descending") {
        this.order = "desc";
      }
      this.orField = row.prop;
      this.getList();
    },
    //显示修改输入框
    editShowEvt(e, s) {
      this.editShowInp = e.id;
      this.editName = s;
      this.$nextTick(_ => {
        this.$refs.editInput.$refs.input.focus();
      });
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        for (let key in this.total) {
          if (column.property == key) {
            sums[index] = this.total[key];
          }
        }
        if (index === 0) {
          sums[index] = this.zonghe;
          return;
        } else if (index === 1) {
          sums[index] = this.amount_total;
          return;
        } else if (index === 3 ) {
          sums[index] = this.user_total;
          return;
        }
        // else if (index === 10) {
        //   sums[index] = this.used_ai_coin;
        //   return;
        // }
      });
      return sums;
    },

    //按下键盘事件
    handKeyCode(e) {
      e = e || window.event;
      //Page Up 翻页
      if (e.keyCode == 34) {
        if (this.allLabel == true) {
          return;
        }
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          e.preventDefault();
          this.arrowRightEvt()
          this.inputValue_box = ''
          return;
        }
        this.loading = true
        e.preventDefault();
        delay(() => {
          this.currentPage1++;
          this.getList()
        }, 300);
      }
      // Page Down向后分页
      if (e.keyCode == 33) {
        this.loading = true
        delay(() => {
          if (this.currentPage1 <= 1) {
            this.currentPage1 = 1;
          } else {
            this.currentPage1--;
          }
          this.getList()
        }, 300);
      }
    },
    //获取页面数据
    // getList() {
    //     let date = {
    //         start: this.value2[0],
    //         end: this.value2[1]
    //     };
    //     let date1 = {
    //         start: this.value1[0],
    //         end: this.value1[1]
    //     };

    //     var start = Math.floor(date.start / 1000);
    //     var end = Math.floor(date.end / 1000);
    //     // 将选定的日期转换为当天的最后一秒
    //     var lastVaccineDate = new Date(end * 1000);
    //     lastVaccineDate.setHours(23, 59, 59);
    //     var endTimestamp = Math.floor(lastVaccineDate.getTime() / 1000);


    //     AdminIcoMeLabelApi({
    //         start: start || '',
    //         end: endTimestamp || '',
    //         start_e: date1.start || '',
    //         end_e: date1.end || '',
    //         type: this.recharge,
    //         page: this.currentPage1,
    //         orField: this.orField,
    //         orWhere: this.order,
    //         limit: this.paginationInput,
    //         username:this.username,
    //         c:this.c
    //     }).then(res => {
    //         this.tableData = res.data.order;
    //         this.total = res.data.total;
    //         this.amount_total = res.data.amount_total;
    //         this.user_total = res.data.user_total;

    //         this.pagefenye = true;  //点击分页 滚动条为0
    //         let as = document.querySelector('.el-table__body-wrapper')
    //         as.scrollTop = 0
    //         this.imgScrollEvt(as)
    //         this.loading = false;
    //         this.dataLoaded = true; // 数据加载完成，修改dataLoaded的状态
    //     });
    // },
    getList() {
    

      // 处理 value1（例如：收入时间）
        let date1 = {};
        if (this.value1 && this.value1.length === 2) {
          date1 = {
                start: Math.floor(this.value1[0] / 1000), // 毫秒转秒
                end: Math.floor(this.value1[1] / 1000)
            };
            // 将日期信息存入 sessionStorage
            sessionStorage.setItem('dateRange', JSON.stringify(date1));
        }



      let date3 = {};
      if (this.value3 && this.value3.length === 2) {
        date3 = {
          start: Math.floor(this.value3[0] / 1000),
          end: Math.floor(this.value3[1] / 1000)
        };
      }
      let date4 = {};
      if (this.value4 && this.value4.length === 2) {
        date4 = {
          start: Math.floor(this.value4[0] / 1000),
          end: Math.floor(this.value4[1] / 1000)
        };
      }
      let date5 = {};
      if (this.value5 && this.value5.length === 2) {
        date5 = {
          start: Math.floor(this.value5[0] / 1000),
          end: Math.floor(this.value5[1] / 1000)
        };
      }

      // 构造请求参数
      const params = {
    
        // 收入时间
        start_e: date1.start || '',
        end_e: date1.end || '',

        expire_time_start: date3.start || '',
        expire_time_end: date3.end || '',

        first_ai_time_start: date4.start || '',
        first_ai_time_end: date4.end || '',

        last_ai_time_start: date5.start || '',
        last_ai_time_end: date5.end || '',
        // 其他参数...
        type: this.recharge,
        page: this.currentPage1,
        orField: this.orField,
        orWhere: this.order,
        limit: this.paginationInput,
        username: this.username,
        c: this.c,
        user: this.user,
        name: this.name,
        Members: this.Members,
        NewAi: this.NewAi,
        back_status: this.back_status,
        remark: this.remark,
        kind:2,
      };
      // 发起请求
      AdminIcoMeLabelApi(params).then(res => {
        this.tableData = res.data.order;
        this.total = res.data.count;
        this.zonghe = res.data.total
        this.amount_total = res.data.amount_total;
        this.user_total = res.data.user_total;
      this.used_ai_coin = res.data.used_ai_coin;

        this.pagefenye = true;
        let as = document.querySelector('.el-table__body-wraperp');
        as.scrollTop = 0;
        this.imgScrollEvt(as);
        this.loading = false;
        this.dataLoaded = true;
      });
    },
    //清除搜索条件
    cleanUpEvt() {
      this.authorIdInput = "";
      this.remtInput = "";
   
      this.value1 ='';
      this.value3 ='';
      this.remark ='';
      this.value4 ='';
      this.value5 ='';

      this.RechargeName = "请选择";
      this.vipName = "新老会员";
      this.currentPage1 = 1;
      this.Members_e = '参考会员'
      this.username = ''
      this.Members = ''
      this.back_status = ''
      this.user = ''
      sessionStorage.removeItem('dateRange');
      this.$refs.sortTable.clearSort();
      AdminIcoMeLabelApi({c: this.c, kind:2,}).then(res => {
        this.tableData = res.data.order;
        this.total = res.data.count;
        this.zonghe = res.data.total
        this.paginationInput = 96;
        this.amount_total = res.data.amount_total;
        this.user_total = res.data.user_total;
      this.used_ai_coin = res.data.used_ai_coin;

        this.pagefenye = true;  //点击分页 滚动条为0
        let as = document.querySelector('.el-table__body-wraperp');
        as.scrollTop = 0;
        this.imgScrollEvt(as);

      });
    },
    clearEvt1() {
      this.RechargeName = "请选择";
      AdminIcoMeLabelApi({c: this.c,  kind:2, }).then(res => {
        this.tableData = res.data.order;
        this.paginationInput = res.data.limit;
        this.currentPage1 = res.page;
        this.total = res.data.count;
        this.zonghe = res.data.total
        this.totalRow = res.totalRow;
        this.amount_total = res.data.amount_total;
        this.user_total = res.data.user_total;
      this.used_ai_coin = res.data.used_ai_coin;

      });
    }
  },
  //点击X后清理数据后并更改值
  computed: {},
  watch: {
    '$store.getters.location': function (newLocation, oldLocation) {
      this.c = newLocation
    },
    value2: function (newVal, oldVal) {
      this.isValue2Empty_box = !newVal;
    },
    value1: function (newVal, oldVal) {
      this.isValue1Empty_box = !newVal;
    },
    value3: function (newVal, oldVal) {
      this.isValue3Empty_box = !newVal;
    },
    value4: function (newVal, oldVal) {
      this.isValue4Empty_box = !newVal;
    },
    value5: function (newVal, oldVal) {
      this.isValue5Empty_box = !newVal;
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../../style/space.less");
@import url("../../../style/income.less");
/deep/.el-table th.el-table__cell{
  background: #F5F7FA !important;
}


@media screen and (min-width: 0px) and (max-width: 1920px) {
  .form_e {
    width: 1200px !important;
  }

  /deep/.el-table__footer-wrapper {
    top: 115px !important;
  }
}


.item {
  margin-top: 10px;
}

/deep/.el-input__suffix {
  color: #409eff;
}

/deep/.el-main {
  overflow: unset !important;
}

.search_box {
  position: absolute;
  top: 20px;
  left: 50px;
  width: 320px;
  height: 470px;
  border-radius: 10px;
  background-color: #fff;
  display: flex;
  justify-content: space-evenly;
  z-index: 999;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 20px 10px;
  box-shadow: 0 0 10px 1px #e5e5e5;

  /*visibility: hidden;*/
  .num_box {
    width: 127px;
    border: 1px solid #e4e3e3;
    border-radius: 3px;
    margin-top: 5px;
  }
}

.all_text {
    background-color: #409eff;
    font-size: 13px;
    color: #fff;
    cursor: pointer;
    height: 26px;
    border-radius: 3px;
    width: 50px;
    text-align: center;
    line-height: 26px;
}

.caoz {
  margin-top: 8px;
  display: flex;
}



.block1 {
  visibility: hidden;
}

.block1>div {
  display: none;
}

.clear {
  position: relative;
  height: 50px;

  span:nth-last-child(1) {
    background-color: #fff;
    border: 1px solid #e5e5e5;
    font-size: 13px;
    color: #c4c3c3;
    border-radius: 3px;
    position: absolute;
    right: 5px;
    bottom: -6px;
    padding: 0 10px;
    cursor: pointer;
  }
}

.demo-table-expand {
  background-color: #f2f2f2;
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  padding: 0 20px;
  width: 30%;
}

.name_box {
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;

  i {
    cursor: pointer;
    display: none;
  }
}

.name_box:hover>i {
  display: block;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.num_box button {
  width: 137px;
  border: 1px solid #858585;
  background-color: #fff;
  color: #c4c3c3;
}

.rowClassOne {
  background-color: #e7ecff;
}

.rowClassTwo {
  color: #222222;
  background-color: #1c43ce;
}

.rowClassThree {
  background-color: #6a88f1;
}

.el-dropdown-link {
  cursor: pointer;
}

.notes_box {
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.my-icon {
  cursor: pointer;
  width: 25px;
}

/deep/.el-table thead {
  font-size: 12px;
}

/deep/.el-table__footer-wrapper {
  position: fixed;
  top: 115px;
  z-index: 111;
}

/deep/.el-table__fixed-footer-wrapper {
  display: none;
}

/deep/.el-badge__content.is-fixed {
  display: none;
}

/deep/.el-input__inner {
  color: #409eff;
  cursor: pointer;
}

.clear_ev {
  position: absolute;
  right: 10px;
}

.vip-button {
  color: #000 !important;
  background-color: #bcd9f8d4 !important;
}

/deep/.vip .el-input__inner {
  background-color: #bcd9f8d4 !important;
  color: #000;
}

/deep/.gutter {
  background: #F5F7FA !important;
}

/* 朝上排序样式 */
/deep/.el-table .ascending .sort-caret.ascending {
  background-color: #f00 !important;
  background: url("../../../img/12.png") no-repeat -4px -3px  !important;
  background-size: 11px 14px !important;
  width: 40px;
  height: 58px;
  z-index: 11;
}

/* 朝下排序样式 */
/deep/.el-table .descending .sort-caret.descending {
  background: url("../../../img/22.png") no-repeat -5px 2px !important;
  background-size: 11px 14px !important;
  width: 40px;
  height: 25px;
}

/deep/.el-table .descending .sort-caret.descending {
  border-top-color: #fff;
}

/* 朝上字体样式 */
/deep/.el-table__header .ascending .cell {
  color: #409EFF!important;
}

/* 朝下字体样式 */
/deep/.el-table__header .descending .cell {
  color: #409EFF!important;
}

.orange {
  /deep/.el-input__inner {
    background-color: #bcd9f8d4 !important;
    color: #222222;
  }

  /deep/.el-input__suffix {
    color: #222222;
  }
}

.your-css-class {
  background-color: #bcd9f8d4 !important;
  z-index: 9999;

  input {
    background-color: #bcd9f8d4 !important;
  }
}

.your-css-class_box {
  background-color: #bcd9f8d4 !important;

  input {
    background-color: #bcd9f8d4 !important;
  }
}

.orange {
  /deep/.el-input__inner {
    background-color: #bcd9f8d4 !important;
    color: #222222;
  }

  /deep/.el-input__suffix {
    color: #222222;
  }
}


/deep/.select_input .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}

/deep/ .select_input .el-input__icon {
  line-height: 30px !important;

}

.vip_e {
  background: #bcd9f8d4 !important;
  color: #000 !important;
}


//调整日期选择器的盒子大小进行修改
//调整日期选择器的盒子大小进行修改
/deep/.el-range-editor--mini{
    height: 28px !important;
  }
  .all_input {
  margin-top: 10px;
  margin-left: 15px;
  display: flex;
  align-items: center;

  span {
    width: 55px;
    font-size: 11px;
    text-align: end;
    margin-right: 10px;
  }

  .el-input {
    width: 160px;
    height: 40px;
    border: 1px solid;
    border-radius: 5px;
  }

  .el-select {
    border: 1px solid;
    border-radius: 5px;
  }

  /deep/.el-input__icon {
    line-height: 30px !important;
    cursor: pointer;
  }
}
.all_input_ect {
  /deep/.el-input__icon {
    line-height: 18px !important;
    cursor: pointer;
    margin-left: -15px !important;
  }
}
/deep/.sousuo .el-input__inner {
  height: 37px !important;
  cursor: pointer;
}


/deep/ .el-input .el-input__clear:hover{
color: #f00 !important;
}
/deep/ .el-date-editor .el-range__close-icon{
color: #f00 !important;
}
/deep/.el-select .el-input .el-icon-circle-close{
  color: #f00 !important;
}
/deep/.el-table th.el-table__cell{
    background: #F5F7FA !important;
    padding: 0 !important;
  }


  /deep/.source_ID{
      margin-left: 15px !important;
    }
/deep/.sousuo .el-dialog__header{
  padding: 0px 20px 10px !important;
}
/deep/.sousuo{
  border-radius: 8px !important;
}



</style>
<style>
.your-css-class .el-range-input {
  background-color: #8fc6ff00 !important;
}

.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

.selt {
  color: #909399 !important;
}

::placeholder {
  color: #858585 !important;
}

.border_box {
  border: 1px solid #858585 !important;
  border-radius: 5px
}
</style>



// WEBPACK FOOTER //
// src/income/components/AI_income/index.vue